export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || ''

export const GA_TRACKING_CODE = process.env.REACT_APP_GA_TRACKING_CODE || ''
